import { Link } from 'react-router-dom';
import { manhwaList } from '@/mocks/manhwa';

export default function PopularWorks() {
  const featured = manhwaList.slice(0, 6);

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-foreground-950">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-4 mb-10 md:mb-5">
          <div>
            <span className="inline-block px-4 py-1.5 rounded-full border border-primary-400/40 text-primary-400 text-sm mb-4 whitespace-nowrap">
              热门推荐
            </span>
            <h2 className="text-2xl md:text-4xl lg:text-5xl font-bold font-heading text-background-50">
              本周热门韩漫
            </h2>
          </div>
          <Link
            to="/category/all"
            className="whitespace-nowrap text-primary-400 hover:text-primary-300 text-sm font-medium cursor-pointer transition-colors inline-flex items-center gap-1"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
          {featured.map((manhwa) => (
            <Link
              key={manhwa.id}
              to={`/article/${manhwa.id}`}
              className="group cursor-pointer"
            >
              <div className="relative overflow-hidden rounded-lg aspect-[3/4] mb-3">
                <img
                  src={manhwa.coverImage}
                  alt={manhwa.title}
                  title={`${manhwa.title} - 韩国漫画免费在线`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-3">
                  <span className="text-background-50 text-xs font-medium">{manhwa.status}</span>
                </div>
                {manhwa.status === '连载中' && (
                  <span className="absolute top-2 left-2 bg-primary-500 text-background-50 text-[10px] px-2 py-0.5 rounded-full whitespace-nowrap">
                    连载
                  </span>
                )}
              </div>
              <h3 className="text-sm font-semibold text-background-50 group-hover:text-primary-400 transition-colors line-clamp-1">
                {manhwa.title}
              </h3>
              <div className="flex items-center gap-2 mt-1">
                <span className="text-xs text-foreground-400">{manhwa.author}</span>
                <span className="text-foreground-600">·</span>
                <span className="text-xs text-accent-400 flex items-center gap-1">
                  <i className="ri-star-fill text-[10px]"></i>
                  {manhwa.rating}
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}